import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { GetRepairInvoiceTypeResponseInterface } from '../definitions/get-repair-invoice-type-response.interface';

@Injectable({ providedIn: 'root' })
export class GetRepairInvoiceTypesService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getRepairInvoiceTypes(partnerId: string): Observable<Array<GetRepairInvoiceTypeResponseInterface>> {
    const url = `${this.configService.config.rest.apiV2Url}/repair-invoice-types`;
    const params = new HttpParams().set('partnerId', partnerId);

    return this.client.get<Array<GetRepairInvoiceTypeResponseInterface>>(url, { params }).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
